import router, { RouteItemType } from '~/core/router';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import {
  getResetPasswordTitle,
  ResetPasswordPath,
} from '~/modules/auth/constants';
import { AUTH_CALLBACK_PATH } from '~/projects/polyllm-chat/components/AuthCallback/providers';

const PolyLLMResetPassword = lazyComponentLoader(
  () => import('~/projects/polyllm-chat/components/ResetPassword'),
);

const PolyLLMResetPasswordRoute: RouteItemType = {
  Component: PolyLLMResetPassword,
  path: ResetPasswordPath,
  getTitle: getResetPasswordTitle,
};

const PolyLLMAuthCallback = lazyComponentLoader(
  () => import('~/projects/polyllm-chat/components/AuthCallback'),
);

const PolyLLMAuthCallbackRoute: RouteItemType = {
  Component: PolyLLMAuthCallback,
  path: AUTH_CALLBACK_PATH,
  getTitle: () => 'ChatWithAI',
};

router.setSignInRedirectPath('/');
router.addAuthRoutes([PolyLLMResetPasswordRoute, PolyLLMAuthCallbackRoute]);
